const SSR_CACHE_SCHEMA_VERSION = 3;
const SSR_CACHE_TAG = 'ssr-cache';

export { SSR_CACHE_SCHEMA_VERSION, SSR_CACHE_TAG };
